var React = require('react');

function Dialog (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"36","cy":"36","r":"34","stroke":"#4555C2","strokeWidth":"4","key":0}),React.createElement("g",{"fill":"#4555C2","transform":"translate(24 24)","key":1},[React.createElement("rect",{"width":"4","height":"24","x":"10","rx":"2","key":0}),React.createElement("rect",{"width":"24","height":"4","y":"10","rx":"2","key":1})])]));
}

Dialog.defaultProps = {"width":"72","height":"72"};

module.exports = Dialog;

Dialog.default = Dialog;
